import config from '@/config'

const exchangeTypeLib = {
  install(Vue) {
    function definePropGet(name, obj) {
      Object.defineProperty(Vue.prototype, name, {
        get: () => obj,
      })
    }

    definePropGet('$exchangeType', { type: config.currencies.default })

    Vue.mixin({
      created() {
        if (this.changedCost) {
          this.$evt.$on('changedCost', this.changedCost)
        }
      },

      destroyed() {
        if (this.changedCost) {
          this.$evt.$off('changedCost', this.changedCost)
        }
      },

      methods: {
        convertDailyCosts(data, displayCurrency, getExchangeRate, context) {
          data.forEach((item) => {
            if (displayCurrency === item.currency) {
              item.cost = item.cost
              item.credit = item.credit
            } else if (config.platform.isGCP && displayCurrency === 'USD') {
              item.cost /= item.currency_conversion_rate
              item.credit /= item.currency_conversion_rate
            } else {
              const rate = getExchangeRate(item.currency, context) || 1
              if (displayCurrency === 'KRW') {
                item.cost *= rate
                item.credit *= rate
              } else {
                const targetRate =
                  getExchangeRate(displayCurrency, context) || 1
                if (item.currency === 'KRW') {
                  item.cost /= targetRate
                  item.credit /= targetRate
                } else {
                  item.cost = (item.cost * rate) / targetRate
                  item.credit = (item.credit * rate) / targetRate
                }
              }
            }
          })
          return data
        },
      },
    })
  },
}

export default exchangeTypeLib
